import { html } from "lit";
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import { BaseComponent } from "../../features/base-component/base-component";
import store from "../../store/store";
import { UserProfile } from "../user-profile/user-profile.interface";
import { smallSpinner } from "../../common/constants/api-constants";
import { StoreState } from "../../store/store.interface";
import { getCartStatus } from "../cart/shop-cart/store/shop-cart.selectors";
import { ActionStatus } from "../../common/constants/action-status";
import { selectUser } from "../user-profile/user-profile.selectors";
import { getCartPageUrl } from "../../common/utils/cart-util";
import emit from "../../common/events";
import { getShopCart } from "../cart/shop-cart/thunks/get-shop-cart.thunk";
import { getInitializeCartStatus } from "../cart/initialize-cart/utils/initialize-cart.util";
import environment from "../../common/environment";

/**
 * An element to redirect to the cart page.
 */

 @customElement('mhecomm-view-cart')
 export class ViewCart extends connect(store)(BaseComponent) {

    /**
     *  Label Name
     */
    @property()
    labelname: string | undefined;

    /**
     * The store to checkout to. If not set the national checkout will be used.
     */
    @property()
    store?: string = environment().checkoutFlow;

    /**
     * Analytics event subarea field.
     */
    @property()
    subarea?: string;

    /**
     * The button classes.
     */
    @property()
    btnClass = 'btn btn-lg btn-primary';

    /**
     * The button div classes.
     */
    @property()
    btnDivClass = 'd-grid';

    @state()
    private user?: UserProfile;

    @state()
    private cartPageUrl: string | undefined;

    /**
     * Flag to indicate whether viewcart button is loading
     */
    @state()
    private isLoading = false;

    protected async firstUpdated(_changedProperties: Map<string | number | symbol, unknown>) {
      super.firstUpdated(_changedProperties);

      await store.dispatch(getShopCart({store: this.store}));
    }
  
    renderComp() {
      return html `
        <div class="${this.btnDivClass} gap-2" @click="${this._onClick}" @keydown="${this._onKeyDown}">
          <slot name="customButton">
            <button
                id="btn-${this.id}"
                class=${this.btnClass} 
                ?disabled=${this.isLoading}>${this.labelname} 
                ${this.isLoading ? smallSpinner() : '' }
            </button>
          </slot>
        </div>
      `;
    }

    stateChanged(state: StoreState) {
      this.isLoading = getCartStatus(state) === ActionStatus.loading || getInitializeCartStatus(state) === ActionStatus.loading;
      if(getCartStatus(state) === ActionStatus.succeeded) {
        this.user = selectUser(state);
        this.cartPageUrl = getCartPageUrl(this.user, this.store);
      }
    }

    _onClick() {
      if (this.cartPageUrl) {
        this.emitViewCart(this.cartPageUrl);
        window.location.href = this.cartPageUrl;
      }
    }

    /**
     * Handle keyboard events for accessibility - responds to Enter and Space keys
     */
    _onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this._onClick();
      }
    }

    private emitViewCart(cartPageUrl) {
      emit({
        element: this,
        name: 'view-cart',
        detail: {
          label: "View Cart",
          href: cartPageUrl,
          subarea: this.subarea
        }
      });
    }
 }

declare global {
    interface HTMLElementTagNameMap {
      'mhecomm-view-cart': ViewCart;
    }
  }